<span
  *ngFor="let item of items"
  class="skeleton-loader"
  [attr.aria-label]="ariaLabel"
  aria-busy="true"
  aria-valuemin="0"
  aria-valuemax="100"
  [attr.aria-valuetext]="loadingText"
  role="progressbar"
  tabindex="0"
  [ngClass]="{
    circle: appearance === 'circle',
    progress: animation === 'progress',
    'progress-dark': animation === 'progress-dark',
    pulse: animation === 'pulse'
  }"
  [ngStyle]="theme"
>
</span>
